// extracted by mini-css-extract-plugin
module.exports = {"sDuration":"sDuration_sDuration__DjEvw","sPaid":"sDuration_sPaid__xAbIn"};